// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-page-payment-screen .logo-container {
  justify-content: center;
}

.payment-modal-portal .close-button {
  background-color: transparent;
}

.payment-modal-overlay {
 background-color: rgba(0, 0, 0, 0.5);
 z-index: 10;
  position: fixed;
  inset: 0;
}

.payment-modal {
  overflow-y: auto;
  padding: 24px;
  margin: 10% auto 0;

  width: 100%;
  min-height: 200px;
  max-height: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 20px 20px 0 0;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: var(--very-light-gray);
}

.payment-modal-overlay .ReactModal__Content--after-open {
  animation: customEnterModalAnimation 0.5s ease-in-out;
}

.payment-modal-overlay .ReactModal__Content--before-close {
  opacity: 0;
  animation: customLeaveModalAnimation 0.5s ease-in-out;
}

@keyframes customEnterModalAnimation {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0%);
  }
}

@keyframes customLeaveModalAnimation {
  0% {
    opacity: 1;
    transform: translateY(0%);
  }
  99% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(100%);
  }
}

.page-payment-screen .offer {
  font-weight: 500;
  font-size: 36px;
  line-height: 38px;
}

.page-payment-screen .page-title {
  font-weight: 800;
  line-height: 29px;
  font-size: 22px;
  margin: 0 0 20px;
}

.page-payment-screen .payment-method {
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;
  max-width: 420px;
  margin: 0 auto;
}

.page-payment-screen .floating-container {
  --floating-container-width: 100%;

  width: var(--floating-container-width);
  max-width: 420px;
  margin: 0 auto;
  backdrop-filter: blur(3.92342px);
  padding: 16px 0;
  box-sizing: border-box;
}

.page-payment-screen .apple-pay-container {
  margin-top: 22px;
  min-height: 42px;
}

.page-payment-screen .button-container {
  margin: 22px auto 0;
}

.page-payment-screen .cancel-container {
  margin-top: 20px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: white;
}

.page-payment-screen .cancel-container svg {
  display: none;
}

.page-payment-screen .cancel-container span {
  padding-top: 2px;
  margin-left: 5px;
}

.page-payment-screen .wallet-container {
  margin-bottom: 10px;
}

.page-payment-screen .money-guarantee-container {
  position: relative;
  margin-bottom: 40px;
}

.page-payment-screen .money-guarantee-container svg {
  position: absolute;

  right: 16px;
  bottom: -48px;
}

.page-payment-screen .input-with-indicator-container {
  --input-side-padding: 20px;
  --input-border-radius: 8px;
  --icon-width: 25px;
  --icon-side-offset: 16px;

  --input-border-color: var(--light-gray);
  --input-background-color: var(--dark-gray);
}

.page-payment-screen .before-plan-subscription {
  max-width: calc(96vw);

  color: var(--dark-gray);
  margin: 8px auto 0;

  line-height: 16px;
  font-weight: 400;
  font-size: 12px;
}

.page-payment-screen .guarantees-container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-feature-settings:
    'ss02' on,
    'liga' off;

  font-size: 12px;
  font-weight: 400;
  line-height: 130%;
  color: var(--green-mint);

  margin-top: 8px;
}

.page-payment-screen .guarantees-container svg {
  margin-right: 9px;
  stroke: var(--green-mint)
}

.page-payment-screen .text-block.subscriptions-details .text-with-icon-wrapper .text{
  font-size: 13px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
  color: var(--dark-gray);
}

.page-payment-screen .buttons-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.page-payment-screen .stripe-wallet-container {
  flex: 1;
}

.page-payment-screen .stripe-wallet-container.gp-wallet-container {
  min-width: 236px;
}

.page-payment-screen .paypal-container {
  flex: 1;
}

.page-payment-screen .policy-container {
  margin: 20px auto 25px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
}

.page-payment-screen .policy-container a {
  color: var(--orange);
  text-decoration: none;
}

.page-payment-screen .policy-container a::after,
.page-payment-screen .policy-container a::before {
  content: '';
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/payment-screen.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;CACC,oCAAoC;CACpC,WAAW;EACV,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;;EAElB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,6DAA6D;EAC7D,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;;EAEhC,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;;EAExB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;;EAErB,uBAAuB;EACvB,kBAAkB;;EAElB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB;;cAEY;;EAEZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;;EAExB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;AACb","sourcesContent":[".header-page-payment-screen .logo-container {\n  justify-content: center;\n}\n\n.payment-modal-portal .close-button {\n  background-color: transparent;\n}\n\n.payment-modal-overlay {\n background-color: rgba(0, 0, 0, 0.5);\n z-index: 10;\n  position: fixed;\n  inset: 0;\n}\n\n.payment-modal {\n  overflow-y: auto;\n  padding: 24px;\n  margin: 10% auto 0;\n\n  width: 100%;\n  min-height: 200px;\n  max-height: 100%;\n  height: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border-radius: 20px 20px 0 0;\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  background-color: var(--very-light-gray);\n}\n\n.payment-modal-overlay .ReactModal__Content--after-open {\n  animation: customEnterModalAnimation 0.5s ease-in-out;\n}\n\n.payment-modal-overlay .ReactModal__Content--before-close {\n  opacity: 0;\n  animation: customLeaveModalAnimation 0.5s ease-in-out;\n}\n\n@keyframes customEnterModalAnimation {\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0%);\n  }\n}\n\n@keyframes customLeaveModalAnimation {\n  0% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n  99% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n}\n\n.page-payment-screen .offer {\n  font-weight: 500;\n  font-size: 36px;\n  line-height: 38px;\n}\n\n.page-payment-screen .page-title {\n  font-weight: 800;\n  line-height: 29px;\n  font-size: 22px;\n  margin: 0 0 20px;\n}\n\n.page-payment-screen .payment-method {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 120%;\n  max-width: 420px;\n  margin: 0 auto;\n}\n\n.page-payment-screen .floating-container {\n  --floating-container-width: 100%;\n\n  width: var(--floating-container-width);\n  max-width: 420px;\n  margin: 0 auto;\n  backdrop-filter: blur(3.92342px);\n  padding: 16px 0;\n  box-sizing: border-box;\n}\n\n.page-payment-screen .apple-pay-container {\n  margin-top: 22px;\n  min-height: 42px;\n}\n\n.page-payment-screen .button-container {\n  margin: 22px auto 0;\n}\n\n.page-payment-screen .cancel-container {\n  margin-top: 20px;\n  display: flex;\n  -webkit-box-pack: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: white;\n}\n\n.page-payment-screen .cancel-container svg {\n  display: none;\n}\n\n.page-payment-screen .cancel-container span {\n  padding-top: 2px;\n  margin-left: 5px;\n}\n\n.page-payment-screen .wallet-container {\n  margin-bottom: 10px;\n}\n\n.page-payment-screen .money-guarantee-container {\n  position: relative;\n  margin-bottom: 40px;\n}\n\n.page-payment-screen .money-guarantee-container svg {\n  position: absolute;\n\n  right: 16px;\n  bottom: -48px;\n}\n\n.page-payment-screen .input-with-indicator-container {\n  --input-side-padding: 20px;\n  --input-border-radius: 8px;\n  --icon-width: 25px;\n  --icon-side-offset: 16px;\n\n  --input-border-color: var(--light-gray);\n  --input-background-color: var(--dark-gray);\n}\n\n.page-payment-screen .before-plan-subscription {\n  max-width: calc(96vw);\n\n  color: var(--dark-gray);\n  margin: 8px auto 0;\n\n  line-height: 16px;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.page-payment-screen .guarantees-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-feature-settings:\n    'ss02' on,\n    'liga' off;\n\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 130%;\n  color: var(--green-mint);\n\n  margin-top: 8px;\n}\n\n.page-payment-screen .guarantees-container svg {\n  margin-right: 9px;\n  stroke: var(--green-mint)\n}\n\n.page-payment-screen .text-block.subscriptions-details .text-with-icon-wrapper .text{\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 17px;\n  text-align: left;\n  color: var(--dark-gray);\n}\n\n.page-payment-screen .buttons-container {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.page-payment-screen .stripe-wallet-container {\n  flex: 1;\n}\n\n.page-payment-screen .stripe-wallet-container.gp-wallet-container {\n  min-width: 236px;\n}\n\n.page-payment-screen .paypal-container {\n  flex: 1;\n}\n\n.page-payment-screen .policy-container {\n  margin: 20px auto 25px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  text-align: left;\n}\n\n.page-payment-screen .policy-container a {\n  color: var(--orange);\n  text-decoration: none;\n}\n\n.page-payment-screen .policy-container a::after,\n.page-payment-screen .policy-container a::before {\n  content: '';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
